// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__l+4s5","main":"Layout_main__gSmqu"};